export default __webpack_public_path__ + "static/media/E8E89620-0053-4BF7-9FF6-7EBEF9A9C3C9_1_105_c.945bf0ec.jpeg";